import React, { ReactNode } from 'react'
import { Heading, Box, Text, Flex } from '@chakra-ui/react'

import { IStatistics } from '@/types/strapi/homePage.interface'

type Props = {
  title: string
  subtitle: string
  statistics?: IStatistics[]
  children?: ReactNode
}

export const Metrics = ({ title, subtitle, statistics, children }: Props) => {
  return (
    <>
      <Flex
        direction={{ base: 'column', lg: 'row' }}
        gap={6}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Box maxW={{ base: 'full', lg: '374px' }}>
          <Heading
            variant="spaceGrotesk"
            as="h2"
            fontSize={{ base: '32px', lg: '40px' }}
            fontWeight={300}
            lineHeight="normal"
            mb={4}
          >
            {title}
          </Heading>
          <Text mb={4}>{subtitle}</Text>
          {children ? <Box mb={4}>{children}</Box> : null}
        </Box>
        {statistics?.length ? (
          <Flex
            direction={'row'}
            flexWrap="wrap"
            alignItems={'flex-start'}
            justifyContent={'flex-start'}
          >
            {statistics.map((item) => (
              <Box key={item.id} width={'50%'} p={3} textAlign="center" my={8}>
                <Text
                  variant="spaceGrotesk"
                  mb={3.5}
                  fontSize={{ base: '32px', md: '44px' }}
                  fontWeight={300}
                >
                  {item.description}
                </Text>
                <Text
                  variant="brandGradient"
                  fontSize={{ base: '14px', md: '16px' }}
                  fontWeight={600}
                >
                  {item.title}
                </Text>
              </Box>
            ))}
          </Flex>
        ) : null}
      </Flex>
    </>
  )
}
